class VariantDrawer extends VariantSelects {
  constructor() {
    super();

    // DOM elements
    this.variantSelector = this.querySelector('#variantSelector');
    this.selectedVariantText = this.querySelector('#selectedVariantText');
    this.drawerOverlay = this.querySelector('#drawerOverlay');
    this.bottomDrawer = this.querySelector('#bottomDrawer');
    this.closeDrawer = this.querySelector('#closeDrawer');
    this.variantsList = this.querySelector('#variantsList');

    this.attachEventListeners();
  }

  attachEventListeners() {
    this.variantSelector.addEventListener('click', this.openDrawer.bind(this));
    this.closeDrawer.addEventListener('click', this.closeDrawerFunction.bind(this));
    this.drawerOverlay.addEventListener('click', this.closeDrawerFunction.bind(this));

    const variantOptions = this.querySelectorAll('.variant-option:not(.unavailable)');
    variantOptions.forEach(option => {
      option.addEventListener('click', () => {
        const variantId = parseInt(option.getAttribute('data-variant-id'));
        this.onVariantChange(variantId);
      });
    });

    // Handle escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.bottomDrawer.classList.contains('active')) {
        this.closeDrawerFunction();
      }
    });

    // Prevent drawer from closing when clicking inside it
    this.bottomDrawer.addEventListener('click', (e) => {
      e.stopPropagation();
    });
  }

  onVariantChange(variantId) {
    this.currentVariant = this.getVariantData().find(variant => variant.id === variantId);

    if (!this.currentVariant) {
      return;
    }

    this.updateSelectedVariantDisplay(this.currentVariant.title);
    this.updateVariantSelection(variantId);
    this.updateMedia();
    this.updateURL();
    this.updateVariantInput();
    this.renderProductInfo();
    this.updateShareUrl();
    this.updatePickupAvailability();
    this.updateInventoryStatus();
    this.removeErrorMessage();

    // Dispatch variant:changed event for frame popup and other components
    document.dispatchEvent(new CustomEvent('variant:changed', {
      detail: {
        variant: this.currentVariant,
        variantId: this.currentVariant.id,
        price: this.currentVariant.price,
        comparePrice: this.currentVariant.compare_at_price,
        variantTitle: this.currentVariant.option1 || this.currentVariant.title
      }
    }));

    this.closeDrawerFunction();
  }

  updateSelectedVariantDisplay(optionValue) {
    // Label (cm or inches) comes from snippets/size-label.liquid via window.peletonSizeLabel.
    this.selectedVariantText.textContent = window.peletonSizeLabel(optionValue, 'long');
    this.selectedVariantText.dataset.value = optionValue;
  }

  updateVariantSelection(selectedId) {
    const variantOptions = this.querySelectorAll('.variant-option');
    variantOptions.forEach(option => {
      const variantId = parseInt(option.getAttribute('data-variant-id'));
      if (variantId === selectedId) {
        option.classList.add('selected');
      } else {
        option.classList.remove('selected');
      }
    });
  }

  openDrawer() {
    this.drawerOverlay.classList.add('active');
    this.bottomDrawer.classList.add('active');
    this.variantSelector.classList.add('active');
  }

  closeDrawerFunction() {
    this.drawerOverlay.classList.remove('active');
    this.bottomDrawer.classList.remove('active');
    this.variantSelector.classList.remove('active');
  }
}

customElements.define('variant-drawer', VariantDrawer);
